module.exports = __webpack_public_path__ + "img/charger-speeds-desktop.793234cf.webp";